import { Box } from "@mui/material";
import {
  AdminReviewSessionViewDto,
  GfFlyerReviewComment,
} from "@swagger/typescript-fetch-goflyer";
import { CommentsPanel } from "../CommentsPanel";

interface Props {
  flyerId: string;
  reqOptions: { headers: { Authorization: string } };
  bootstrap: AdminReviewSessionViewDto | undefined;
  comments: GfFlyerReviewComment[];
}

export function ItemCommentsList({
  flyerId,
  reqOptions,
  bootstrap,
  comments,
}: Props) {
  if (comments.length === 0) return null;

  return (
    <Box data-testid="item-comments-section">
      <CommentsPanel
        flyerId={flyerId}
        reqOptions={reqOptions}
        bootstrap={bootstrap}
        commentsOverride={comments}
      />
    </Box>
  );
}
